import * as types from './actionTypes';
import rest from "../API/api";
import sha1 from "sha1";
import {deleteConsentsSuccess} from "./consentActions";

export function loadSubmissionsSuccess(submissions) {
    //debugger;
  return {type: types.LOAD_SUBMISSION_SUCCESS, submissions};
}

export function deleteSubmissionsSuccess(submissions) {
    //debugger;
    return {type: types.DELETE_SUBMISSION_SUCCESS, submissions};
}

export function updateSubmissionsSuccess(submissions) {
    //debugger;
    return {type: types.UPDATE_SUBMISSION_SUCCESS, submissions};
}

export function addSubmissionsSuccess(submissions) {
    //debugger;
    return {type: types.ADD_SUBMISSION_SUCCESS, submissions};
}

export function readSubmissionSuccess(submission) {
    //debugger;
    return {type: types.READ_SUBMISSION_SUCCESS, submission};
}


// Functions below handle asynchronous calls.
// Each returns a function that accepts a dispatch.
// These are used by redux-thunk to support asynchronous interactions.
export function loadSubmissions(tenant,scope,query,queryType) {
    return function (dispatch) {
        var tempURL;
        //Build REST URL passing Tenant ID since Submissions are stored by Tenant ID in their own collection
        //If scope = "All" then we need to make a call to the REST endpoint for ALL submissions, otherwise if scope is equal to
        //"Tenant" then we need to just focus on this tenant.
        if(scope === "Tenant") {
            tempURL = rest.submissions + '/' + tenant._id;
        }
        else if(scope === "All") {
            tempURL = rest.submissions;
        }
        fetch(tempURL, {
            method: 'PUT',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': tenant.apiKey
            }),
            body: JSON.stringify({
                queryType: queryType,
                query: query
            })
        })
            .then(response => response.json())
            .then(data => {


                //debugger;
                // turn the JSON into a string then into an JS array
               return dispatch(loadSubmissionsSuccess(JSON.parse(JSON.stringify(data))))
            })
            .catch(error => console.error(error));
    };
}

//Makes an API call to the gateway which will update the submission with mongoDB_id that matches the one passed on the URL. API call
//will return the current set of records after the update so we will dispatch a store update with the new records.
export function updateSubmission(tenant,submission) {
    return function (dispatch) {
        //lets define some const. that we can use in the fetch calls below
        //REST API Gateway URLs
        //!!!!!MAKE SURE YOU USE THE SINGULAR "SUBMISSION" endpoint for Updates!!!!!
        let tempURL = rest.submission + '/' + submission._id;
        //Current Tenant record that we will need to update
        const submissionID = submission.id;
         //Update the main MongoDB record
        fetch(tempURL, {
            method: 'PUT',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': tenant.apiKey
            }),
            body: JSON.stringify({
                Name: submission.Name,
                LiscNumber: submission.LiscNumber
            }),
        })
            .then(response => response.json())
            .then(data => {
                // turn the JSON into a string then into an JS array
                return dispatch(updateSubmissionsSuccess(JSON.parse(JSON.stringify(data))))
            })
            .catch(error => console.error(error));
    };
}


//Makes an API call to the gateway which will add the submission under the tenant _id. API call
//will return the current set of records after the deletion so we will dispatch a store update with the new records.
export function addSubmission(tenant,submission) {
    return function (dispatch) {
        let tempURL = rest.submissions + '/' + tenant._id;
        fetch(tempURL, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': tenant.apiKey
            }),
            body: JSON.stringify({
                Name: submission.Name,
                LiscNumber: submission.LiscNumber
            }),
        })
            .then(response => response.json())
            .then(data => {
                return dispatch(addSubmissionsSuccess(JSON.parse(JSON.stringify(data))))
            })
            .catch(error => console.error(error));

    };
}


//Makes an API call to the gateway which will read an submission with mongoDB_id that matches the one passed on the URL. API call
//will return the current record after the read so we will dispatch a store update with the new records.
export function readSubmissions(tenant,id) {
    return function (dispatch) {
        //!!!!!MAKE SURE YOU USE THE SINGULAR "SUBMISSION" endpoint for Adds!!!!!
        let tempURL = rest.submission + '/' + id;
        fetch(tempURL, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': tenant.apiKey
            })
        })
            .then(response => response.json())
            .then(data => {
                // turn the JSON into a string then into an JS array
                return dispatch(readSubmissionSuccess(JSON.parse(JSON.stringify(data))))
            })
            .catch(error => console.error(error));
    };
}

//New Delete a submission using async/await functions in an attempt to fix the delete issue I am seeing on prod
//Makes an API call to the gateway which will delete the submission with mongoDB_id that matches the one passed on the URL. API call
//will return the current set of records after the deletion so we will dispatch a store update with the new records.
export function asyncAwaitDeleteSubmission(tenant,id,scope) {
    return async function (dispatch) {

        let timestamp = Date.now();
        let api_key = tenant.apiKeyCloudinary;
        let api_secret = tenant.apiSecretKeyCloudinary;
        let cloudURL = tenant.cloudinary_destory;

        //Read the customer first, grab the image public ids so we can delete them from cloudinary
        //!!!!!MAKE SURE YOU USE THE SINGULAR "SUBMISSION" endpoint for lookup!!!
        let tempURL = rest.submission + '/' + id;
        const getSubmission = fetch(tempURL, {
            method: 'GET', headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': tenant.apiKey
            })
        });
        const response = await getSubmission;
        const submission = await response.json();

        // Now lets use the submission we found and clear out Cloudinary images
        let consentSignaturePublicId = submission.ConsentSignaturePublicId;
        let consentGuardianSignaturePublicId = submission.ConsentGuardianSignaturePublicId;
        let consentPhotoIdPublicId = submission.ConsentPhotoIdPublicId;

        //console.log("Submission to delete:" + submission);

        if (consentSignaturePublicId !== "") {
            //build a payload and hash it
            let payload_to_sign = "public_id=" + consentSignaturePublicId + "&timestamp=" + timestamp + api_secret;
            let sha1_hash = sha1(payload_to_sign);
            const deleteConsentSignature = fetch(cloudURL, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify({
                    api_key: api_key,
                    public_id: consentSignaturePublicId,
                    signature: sha1_hash,
                    timestamp: timestamp
                }),
            });
            const response = await deleteConsentSignature;
            const result = await response.json();
            //console.log(result.result);
        }
        if (consentGuardianSignaturePublicId !== "") {
            //build a payload and hash it
            let payload_to_sign = "public_id=" + consentGuardianSignaturePublicId + "&timestamp=" + timestamp + api_secret;
            let sha1_hash = sha1(payload_to_sign);
            const deleteGuardianSignature = await fetch(cloudURL, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify({
                    api_key: api_key,
                    public_id: consentGuardianSignaturePublicId,
                    signature: sha1_hash,
                    timestamp: timestamp
                }),
            });
            const response = await deleteGuardianSignature;
            const result = await response.json();
            //console.log(result.result);
        }

        if (consentPhotoIdPublicId !== "") {
            //build a payload and hash it
            let payload_to_sign = "public_id=" + consentPhotoIdPublicId + "&timestamp=" + timestamp + api_secret;
            let sha1_hash = sha1(payload_to_sign);
            const deletePhotoId = await fetch(cloudURL, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify({
                    api_key: api_key,
                    public_id: consentPhotoIdPublicId,
                    signature: sha1_hash,
                    timestamp: timestamp
                }),
            });
            const response = await deletePhotoId;
            const result = await response.json();
            //console.log(result.result);
        }
        //!!!!!MAKE SURE YOU USE THE SINGULAR "SUBMISSION" endpoint for Deletes!!!!!
        //NOW LETS DELETE the submission!
        tempURL = rest.submissions + '/' + id;
        const deleteSubmission = await fetch(tempURL, {
            method: 'DELETE',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': tenant.apiKey
            }),
            body: JSON.stringify({
                scope: scope,
                TenantId: tenant._id
            }),
        });
        const deleteResponse = await deleteSubmission;
        const result = await deleteResponse.json();
        //console.log(result);
        // turn the JSON into a string then into an JS array
        return dispatch(deleteSubmissionsSuccess(JSON.parse(JSON.stringify(result))))

    }
}

/* OLD CODE that seemed to have issue deleting the submissions based on Async and Promises, Moved in new code above to use
// ASYNC and AWAIT
//Makes an API call to the gateway which will delete the submission with mongoDB_id that matches the one passed on the URL. API call
//will return the current set of records after the deletion so we will dispatch a store update with the new records.
export function deleteSubmission(tenant,id,scope) {
    return function (dispatch) {

        const timestamp = Date.now();
        const api_key = tenant.apiKeyCloudinary;
        const api_secret = tenant.apiSecretKeyCloudinary;
        const cloudURL = tenant.cloudinary_destory;

        //Read the customer first, grab the image public ids so we can delete them from cloudinary
        //!!!!!MAKE SURE YOU USE THE SINGULAR "SUBMISSION" endpoint for lookup!!!
        let tempURL = rest.submission + '/' + id;
        fetch(tempURL, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': tenant.apiKey
            })
        })
            .then(response => response.json())
            .then(data => {
                const consentSignaturePublicId = data.ConsentSignaturePublicId;
                const consentGuardianSignaturePublicId = data.ConsentGuardianSignaturePublicId;
                const consentPhotoIdPublicId = data.ConsentPhotoIdPublicId;

                if(consentSignaturePublicId !== "") {
                    //build a payload and hash it
                    let payload_to_sign = "public_id=" + consentSignaturePublicId + "&timestamp=" + timestamp + api_secret;
                    let sha1_hash = sha1(payload_to_sign);
                    fetch(cloudURL, {
                        method: 'POST',
                        headers: new Headers({
                            'Content-Type': 'application/json;charset=UTF-8'
                        }),
                        body: JSON.stringify({
                            api_key: api_key,
                            public_id: consentSignaturePublicId,
                            signature: sha1_hash,
                            timestamp: timestamp
                        }),
                    })
                        .then(response => response.json())
                        .then(data => {
                            //console.log("Signature delete response " + data.result);

                        })
                        .catch(error => console.error(error));
                }
                if(consentGuardianSignaturePublicId !== "") {
                    //build a payload and hash it
                    let payload_to_sign = "public_id=" + consentGuardianSignaturePublicId + "&timestamp=" + timestamp + api_secret;
                    let sha1_hash = sha1(payload_to_sign);
                    fetch(cloudURL, {
                        method: 'POST',
                        headers: new Headers({
                            'Content-Type': 'application/json;charset=UTF-8'
                        }),
                        body: JSON.stringify({
                            api_key: api_key,
                            public_id: consentGuardianSignaturePublicId,
                            signature: sha1_hash,
                            timestamp: timestamp
                        }),
                    })
                        .then(response => response.json())
                        .then(data => {
                            //console.log("Guardian Signature delete response " + data.result);

                        })
                        .catch(error => console.error(error));
                }
                if(consentPhotoIdPublicId !== "") {
                    //build a payload and hash it
                    let payload_to_sign = "public_id=" + consentPhotoIdPublicId+ "&timestamp=" + timestamp + api_secret;
                    let sha1_hash = sha1(payload_to_sign);
                    fetch(cloudURL, {
                        method: 'POST',
                        headers: new Headers({
                            'Content-Type': 'application/json;charset=UTF-8'
                        }),
                        body: JSON.stringify({
                            api_key: api_key,
                            public_id: consentPhotoIdPublicId,
                            signature: sha1_hash,
                            timestamp: timestamp
                        }),
                    })
                        .then(response => response.json())
                        .then(data => {
                            //console.log("Photo delete response " + data.result);

                        })
                        .catch(error => console.error(error));
                }
            })
            .catch(error => console.error(error));
        //!!!!!MAKE SURE YOU USE THE SINGULAR "SUBMISSION" endpoint for Deletes!!!!!
        //NOW LETS DELETE IT!
        tempURL = rest.submissions + '/' + id;
        fetch(tempURL, {
            method: 'DELETE',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': tenant.apiKey
            }),
            body: JSON.stringify({
                scope: scope,
                TenantId: tenant._id
            }),
        })
            .then(response => response.json())
            .then(data => {
                // turn the JSON into a string then into an JS array
                return dispatch(deleteSubmissionsSuccess(JSON.parse(JSON.stringify(data))))
            })
            .catch(error => console.error(error));

    };
}
 */





// WEBPACK FOOTER //
// ./src/actions/submissionActions.js